module.exports = __webpack_public_path__ + "img/背景.d47360ec.png";